<!--
    描述：评价系统 --- 考核项
    时间：2021-03-03
    Created by 王帅
-->
<template>
    <div class="evaluate-score-main filter-layout">
        <div class="filter-box pdt10">
            <el-form ref="searchForm" v-show="filterShow" :model="searchObj" label-width="120px">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="考核类型：" prop="markObj">
                            <el-select
                                v-model="searchObj.markObj"
                                placeholder="请选择考核类型"
                                size="small"
                                clearable
                            >
                                <el-option
                                    v-for="(item, index) in khlx"
                                    :key="'对象' + index"
                                    :label="item.sname"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="类别：" prop="itemType">
                            <el-select
                                v-model="searchObj.itemType"
                                placeholder="类别"
                                size="small"
                                clearable
                            >
                                <el-option
                                    v-for="(item, index) in allOptions"
                                    :key="'类别222' + index"
                                    :label="item.sname"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="名称：" prop="sname">
                            <el-input v-model="searchObj.sname" size="small" placeholder="请输入" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="创建人：" prop="createUser">
                            <el-input v-model="searchObj.createUser" size="small" placeholder="请输入" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发布时间：" prop="startDate">
                            <el-col :span="11">
                                <el-date-picker
                                    class="w100"
                                    v-model="searchObj.startDate"
                                    type="date"
                                    placeholder="请选择时间"
                                    size="small"
                                    value-format="yyyy-MM-dd"
                                    :clearable="false"
                                    :picker-options="startDatePicker"
                                ></el-date-picker>
                            </el-col>
                            <el-col :span="2" class="text-center">~</el-col>
                            <el-col :span="11">
                                <el-date-picker
                                    class="w100"
                                    v-model="searchObj.endDate"
                                    type="date"
                                    placeholder="请选择时间"
                                    size="small"
                                    value-format="yyyy-MM-dd"
                                    :clearable="false"
                                    :picker-options="endDatePicker"
                                ></el-date-picker>
                            </el-col>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="text-right mt5">
                        <el-button
                            type="primary"
                            class="btn-blue"
                            size="small"
                            icon="el-icon-search"
                            @click="doSearch('1')"
                            >查询</el-button
                        >
                        <el-button icon="el-icon-refresh" size="small" @click="doRefresh"
                            >重置</el-button
                        >
                    </el-col>
                </el-row>
            </el-form>

            <!-- 筛选折叠按钮 -->
			<div class="control-btn"
				 @click="filterShow = !filterShow">
				<span v-if="filterShow">
					点击收起
					<svg-icon icon-class="pack-up"
							  class="c-icon ml5"></svg-icon>
				</span>
				<span v-else>筛选
					<svg-icon icon-class="pack-down"
							  class="c-icon ml5"></svg-icon>
				</span>
			</div>
        </div>
        <div class="filter-content primary-layout">
            <!-- 头部按钮 -->
            <div class="primary-header">
                <div class="title">
                    合计考核项：<span class="blue">{{ searchObj.totalResult }}</span> 条
                </div>
                <div class="btnGroups">
                    <el-button
                        size="small"
                        type="success"
                        v-if="roleBtns.includes('score_add')"
                        @click="handleTools('add')"
                        >新增</el-button
                    >
                    <el-button
                        size="small"
                        class="btn-blue"
                        icon="el-icon-refresh"
                        type="primary"
                        @click="doRefresh"
                    ></el-button>
                </div>
            </div>

            <!-- 表格内容 -->
            <div class="primary-content w-table-layout w-table-page">
                <div class="w-table-content">
                    <vxe-table
                        :data="tableObj.tableData"
                        :loading="tableObj.loading"
                        :border="tableObj.border"
                        :resizable="tableObj.resizable"
                        :size="tableObj.size"
                        :height="tableObj.height"
                        highlight-current-row
                        highlight-hover-row
                        auto-resize
                        show-overflow="tooltip"
                        show-header-overflow="tooltip"
                    >
                        <vxe-table-column
                            type="seq"
                            title="序号"
                            width="60"
                            align="center"
                        ></vxe-table-column>
                        <vxe-table-column
                            v-for="(item, index) in activeColumns"
                            :key="item.prop"
                            :field="item.prop"
                            :title="item.title"
                            :min-width="item.minWidth"
                            :width="item.width"
                            :align="item.align"
                            :header-align="item.headerAlign"
                        >
                            <!-- <template v-slot="{ row }" v-if="item.needRender">
                                <span>{{ item.function(row[item.prop]) }}</span>
                            </template> -->
                        </vxe-table-column>
                        <vxe-table-column title="操作" min-width="120" align="center">
                            <template v-slot="{ row }">
                                <el-button
                                    type="success"
                                    size="small"
                                    round
                                    plain
                                    class="table-btn"
                                    v-if="roleBtns.includes('score_edit')"
                                    @click="handleTools('edit', row)"
                                >
                                    <svg-icon icon-class="form-edit"></svg-icon> 编辑
                                </el-button>
                                <el-button
                                    type="danger"
                                    size="small"
                                    round
                                    plain
                                    class="table-btn"
                                    icon="el-icon-delete"
                                    v-if="roleBtns.includes('score_delete')"
                                    @click="handleTools('delete', row)"
                                    >删除
                                </el-button>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </div>
                <div class="w-table-footer" style="font-size: 13px">
                    <vxe-pager
                        :current-page="searchObj.currentPage"
                        :page-size="searchObj.pageSize"
                        :total="searchObj.totalResult"
                        class="text-center"
                        :page-sizes="[10, 20, 50, 100, { label: '全部数据', value: -1 }]"
                        :layouts="[
                            'Total',
                            'Sizes',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'FullJump',
                        ]"
                        @page-change="handlePageChange"
                    >
                    </vxe-pager>
                </div>
            </div>
        </div>

        <!-- 新增弹窗 -->
        <el-dialog
            :visible.sync="dialogObj.visible"
            :width="dialogObj.width"
            :title="dialogObj.title"
            center
            :close-on-click-modal="false"
            :before-close="beforeClose"
            @closed="handleClose"
        >
            <el-form
                ref="addForm"
                :model="formData"
                :rules="rules"
                size="medium"
                label-width="100px"
            >
                <el-form-item label="考核类型" prop="markObj">
                    <el-select
                        v-model="formData.markObj"
                        placeholder="请选择考核类型"
                        clearable
                        @change="onChangeMark"
                    >
                        <el-option
                            v-for="(item, index) in khlx"
                            :key="'对象1' + index"
                            :label="item.sname"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类别" prop="itemType">
                    <el-select
                        v-model="formData.itemType"
                        placeholder="请选择类别"
                        filterable
                        allow-create
                        default-first-option
                        clearable
                        @change="handlChange"
                    >
                        <el-option
                            v-for="(item, index) in itemTypeOptions"
                            :key="index"
                            :label="item.sname"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="名称" prop="sname">
                    <el-input
                        v-model="formData.sname"
                        placeholder="请输入名称"
                        :maxlength="50"
                        show-word-limit
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <el-input
                        v-model="formData.content"
                        placeholder="请输入内容"
                        :maxlength="200"
                        show-word-limit
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item label="考核标准" prop="standard">
                    <el-input
                        v-model="formData.standard"
                        type="textarea"
                        placeholder="请输入考核标准"
                        :maxlength="200"
                        show-word-limit
                        :autosize="{ minRows: 2 }"
                    ></el-input>
                </el-form-item>
            </el-form>

            <!-- footer 组件 -->
            <div slot="footer" class="pdb10 text-center">
                <el-button size="small" class="btn" @click="handleClose"
                    >取 消
                </el-button>
                <el-button
                    type="primary"
                    size="small"
                    class="btn btn-blue"
                    :loading="dialogObj.btnLoading"
                    @click="doSave"
                    >确 定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as Api from "api/evaluateManage/EvaluateItem.js";
import { mapState } from "vuex";

export default {
    name: "EvaluateIndex",
    data() {
        return {
            filterShow: true,
            searchObj: {
                markObj: "",
                itemType: '',
                sname: '',
                createUser: '',
                startDate: "",
                endDate: "",
                currentPage: 1,
                pageSize: 10,
                totalResult: 0,
            },
            // 表格对象
            tableObj: {
                tableData: [],
                loading: false,
                border: true,
                resizable: true,
                size: "small",
                height: "100%",
            },
            startDatePicker: this.beginDate(),
            endDatePicker: this.processDate(),
            // 弹窗对象
            dialogObj: {
                visible: false,
                width: "600px",
                title: "新增",
                type: "add",
                btnLoading: false,
            },
            formData: {
                markObj: undefined,
                itemType: undefined,
                sname: "",
                content: undefined,
                standard: undefined,
            },
            rules: {
                markObj: [
                    {
                        required: true,
                        message: "请选择考核类型",
                        trigger: "change",
                    },
                ],
                itemType: [
                    {
                        required: true,
                        message: "请选择类别",
                        trigger: "change",
                    },
                ],
                sname: [
                    {
                        required: true,
                        message: "请输入名称",
                        trigger: "blur",
                    },
                ],
                content: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
                standard: [
                    {
                        required: true,
                        message: "请输入考核标准",
                        trigger: "blur",
                    },
                ],
            },
            itemTypeOptions: [],
            allOptions: [], // 全部类别
        };
    },
    created() {
        // 初始查询
        this.doSearch();

        // 获取全部类别
        Api.changeMark({ markObj: '' })
            .then(res => {
                this.allOptions = res.data
            })
            .catch(err => {})
    },
    methods: {
        // 开始时间的 pickOption
        beginDate() {
            let that = this;
            return {
                disabledDate(time) {
                    let endTime = "";
                    // endTime = new Date(that.searchObj.endDate).getTime() + 86400000;
                    endTime = new Date(that.searchObj.endDate).getTime();
                    if (endTime) {
                        return time.getTime() > endTime
                    } else {
                        return time.getTime() > Date.now();
                    }
                },
            };
        },

        // 结束时间的 pickOption
        processDate() {
            let that = this;
            return {
                disabledDate(time) {
                    let startTime = "";
                    startTime = new Date(that.searchObj.startDate).getTime() - 86400000;
                    if (startTime) {
                        return time.getTime() < startTime || time.getTime() < Date.now()
                    } else {
                        return time.getTime() < Date.now() - 86400000;
                    }
                },
            };
        },

        // 查询数据
        doSearch(page) {
            if (page) {
                this.searchObj.pageSize = 10
                this.searchObj.currentPage = 1
            }
            let params = {
                size: this.searchObj.pageSize, // 当前每页条数
                current: this.searchObj.currentPage, // 当前页码
                markObj: this.searchObj.markObj, // 考核类型
                itemType: this.searchObj.itemType, // 考核类别
                sname: this.searchObj.sname, // 名称
                createUser: this.searchObj.createUser, // 创建人
                startTime: this.searchObj.startDate, // 创建时间 -- 开始
                endTime: this.searchObj.endDate, // 创建时间 -- 结束
            };
            params.startTime =
                params.startTime === ""
                    ? params.startTime
                    : params.startTime + " 00:00:00";
            params.endTime =
                params.endTime === "" ? params.endTime : params.endTime + " 23:59:59";
            this.tableObj.loading = true;
            Api.getListData(params)
                .then((res) => {
                    // console.log(res)
                    this.tableObj.loading = false;
                    if (res.operationCode === 1) {
                        if(this.searchObj.pageSize != -1){
                            this.searchObj.totalResult = parseInt(res.data.total);
                        }
                        this.tableObj.tableData = res.data.records;
                    }
                })
                .catch((err) => {
                    this.tableObj.loading = false;
                });
        },

        // 刷新
        doRefresh() {
            this.searchObj.pageSize = 10;
            this.searchObj.currentPage = 1;
            this.$refs.searchForm.resetFields()
            // this.searchObj.markObj = "";
            // this.searchObj.itemType = "";
            this.searchObj.startDate = "";
            this.searchObj.endDate = "";

            this.doSearch();
        },

        // 操作函数
        handleTools(type, row) {
            switch (type) {
                case "add":
                    this.dialogObj.visible = true;
                    this.dialogObj.type = "add";
                    this.dialogObj.title = "新增";

                    break;
                case "edit":
                    this.dialogObj.visible = true;
                    this.dialogObj.type = "edit";
                    this.dialogObj.title = "编辑";

                    // 触发考核类型选择
                    this.onChangeMark(row.markObj, row);
                    break;
                case "delete":
                    this.tableObj.loading = true;
                    this.$confirm("确认删除吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            Api.deleteItem({ id: row.id ,isFlag: 0})
                                .then((res) => {
                                    this.tableObj.loading = false;
                                    // 刷新页面
                                    this.doSearch();
                                })
                                .catch((err) => {
                                    this.tableObj.loading = false;
                                });
                        })
                        .catch(() => {
                            this.tableObj.loading = false;
                        });
                    break;
            }
        },

        // 考核类型选择
        onChangeMark(value, row) {
            if (value === "") {
                this.itemTypeOptions = [];
                this.formData.itemType = "";
                this.formData.itemTypeName = "";
                return;
            }
            Api.changeMark({ markObj: value })
                .then((res) => {
                    if (res.operationCode === 1) {
                        this.itemTypeOptions = res.data;
                        this.formData.itemType = "";
                        this.formData.itemTypeName = "";

                        // 触发回显
                        if (row) {
                            this.formData = JSON.parse(JSON.stringify(row));
                            this.formData.itemTypeName = ''
                        }
                    }
                })
                .catch((err) => {
                    this.itemTypeOptions = [];
                    this.formData.itemType = "";
                    this.formData.itemTypeName = "";
                });
        },

        // 类别切换
        handlChange(value) {
            let _noSpaceValue = this.spaceFilter(value);
            // 新增的单独处理
            let _item = this.itemTypeOptions.find((x) => x.id === _noSpaceValue);
            this.formData.itemTypeName = _item ? "" : _noSpaceValue;
        },

        // 确认新增、编辑
        doSave() {
            // 按钮状态loading
            this.dialogObj.btnLoading = true;

            // 表单验证
            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    // console.log(this.formData);
                    let params = Object.assign({}, this.formData);
                    if (params.itemTypeName !== "") {
                        params.itemType = "";
                    } else {
                        params.itemTypeName = this.itemTypeOptions.find(
                            (x) => x.id === params.itemType
                        ).sname;
                    }

                    // 编辑时不更新创建人
                    if (this.dialogObj.type !== "edit") {
                        params.createUserid = this.userInfo.id;
                        params.createUser = this.userInfo.sname;
                    }

                    Api.saveOrUpdateItem(params).then((res) => {
                        if (res.operationCode === 1) {
                            this.dialogObj.visible = false;
                            // 清除表单字段
                            this.resetFields();

                            this.doSearch();
                        }
                    }).catch(err => {
                        this.dialogObj.btnLoading = false;
                    });
                } else {
                    setTimeout(() => {
                        this.dialogObj.btnLoading = false;
                    }, 2000);
                }
            });
        },

        // 重置新增表单
        resetFields() {
            this.dialogObj.btnLoading = false;

            this.$refs.addForm ? this.$refs.addForm.resetFields() : '';
            this.formData.itemType = "";
            this.formData.itemTypeName = "";
            this.formData.id = ''
        },

        // 关闭弹窗
        beforeClose(done) {
            this.resetFields()
            done()
        },

        // 左侧弹窗关闭
        handleClose() {
            this.resetFields()
            this.dialogObj.visible = false
        },

        // 切换分页
        handlePageChange({ currentPage, pageSize }) {
            this.searchObj.currentPage = currentPage;
            this.searchObj.pageSize = pageSize;
            this.doSearch();
        },

        // 数据去除空格
        spaceFilter(data) {
            return data.replace(/\s+/, "");
        },
    },
    computed: {
        // 动态列
        activeColumns() {
            let columns = [
                {
                    prop: "markObjName",
                    title: "考核类型",
                    minWidth: 150,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "itemTypeName",
                    title: "类别",
                    minWidth: 0,
                    width: 120,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "sname",
                    title: "名称",
                    minWidth: 150,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "content",
                    title: "内容",
                    minWidth: 200,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "standard",
                    title: "考核标准",
                    minWidth: 200,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "createUser",
                    title: "创建人",
                    minWidth: 0,
                    width: 100,
                    headerAlign: "center",
                    align: "center",
                },
                {
                    prop: "createDate",
                    title: "创建时间",
                    minWidth: 0,
                    width: 160,
                    headerAlign: "center",
                    align: "center",
                    needRender: true,
                    function: (val) => {
                        return val.slice(0, 10);
                    },
                },
            ];
            return columns;
        },

        // 个人信息
        ...mapState("user", {
            userInfo: (state) => state.userInfo,
        }),

        // 考核类型
        ...mapState("dict", {
            khlx: (state) => state.projectDict.khlx, // 考核类型数组,
        }),

        ...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
    },
};
</script>

<style scoped lang="less"></style>
